import { render, staticRenderFns } from "./AktarilmayanDosyaDetay.vue?vue&type=template&id=25adaeb2&scoped=true"
import script from "./AktarilmayanDosyaDetay.vue?vue&type=script&lang=ts"
export * from "./AktarilmayanDosyaDetay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25adaeb2",
  null
  
)

export default component.exports